import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { forwardRef } from "react";
export const UiSvgIcon = forwardRef((props, ref) => (_jsx(SvgIcon, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_svg_icon.js.map